module.exports = __webpack_public_path__ + "img/settings.e2cfe426.png";